import {  NgModule } from '@angular/core';

import { AuthorizationGuard } from '../guards/authorization-guard';
import { AdminAuthorizationGuard } from 'common/guards/admin-authorization-guard';
import { DefaultRouteGuard } from 'common/guards/default-route-guard';

@NgModule({
    providers: [AuthorizationGuard,AdminAuthorizationGuard,DefaultRouteGuard],
    
})
export class GspGuardsModule { }

